import { render, staticRenderFns } from "./refraction.vue?vue&type=template&id=47e4c7d2&scoped=true&"
import script from "./refraction.vue?vue&type=script&lang=js&"
export * from "./refraction.vue?vue&type=script&lang=js&"
import style0 from "./refraction.vue?vue&type=style&index=0&id=47e4c7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4c7d2",
  null
  
)

export default component.exports